module.exports = __webpack_public_path__ + "static/TANMEMORIES-Regular-ce3f4b2a3c5a8e5de903269a937f8bb4.eot";